const consumerFinanceRoutes = [
  {
    path: '/consumer-finance',
    name: 'ConsumerFinance',
    meta: {
      index: 36
    },
    component: () => import('@/views/consumerFinance/Index.vue')
  },
  {
    path: '/consumer-finance/shopping-cart',
    name: 'ConsumerFinanceShoppingCart',
    meta: {
      index: 40
    },
    component: () => import('@/views/consumerFinance/ShoppingCart.vue')
  }
]
export default consumerFinanceRoutes
